import {UIState} from "../../../data/UIState";
import {observer} from "mobx-react";
import * as React from "react";
import {CommentDataInterface} from "../../../data/FullPostModalData";
import {CommentReply} from "./CommentReply";
import {CommentReplyAdd} from "./CommentReplyAdd";

import './CommentReplies.pcss';

interface Props {
  comment:any;
  addReply:(commentData:CommentDataInterface)=>Promise<void>;
  commentPeriodHasEnded:boolean;
}

@observer
export class CommentReplies extends React.Component<Props> {

  handleAddReply = (reply:string) => {
    const commentData:CommentDataInterface = {
      comment:reply,
      parentCommentId:this.props.comment._id,
    }
    return this.props.addReply(commentData);
  }

  render(){
    const originalCommenter = this.props.comment.userId ? this.props.comment.userId.nameOrNickname : '';

    return (

        <div className={`comment-replies${!this.props.comment.replies||this.props.comment.replies.length==0?' no-replies':''}`}>
            {this.props.comment.replies && this.props.comment.replies.map((reply, idx) =>
                <CommentReply key={idx} reply={reply} />
            )}
            {!this.props.commentPeriodHasEnded &&
                <CommentReplyAdd addReply={this.handleAddReply} originalCommenter={originalCommenter} />
            }
        </div>
    );
  }

}
